import { createStructuredSelector } from "reselect";
import {
    UNIT_LIST,
    UNIT_LIST_SUCCESS,
    UNIT_LIST_ERROR,
    UNIT_PAGE_SET,
    UNIT_HEADER,
    UNIT_SEARCH_SET,
    UNIT_SEARCH_CHANGE,
    UNIT_ADD_SET,
    UNIT_ADD_MODAL_SET,
    UNIT_ADD,
    UNIT_ADD_SUCCESS,
    UNIT_ADD_ERROR,
    UNIT_ADD_CHANGE,
    UNIT_EDIT_SET,
    UNIT_EDIT_CHANGE,
    UNIT_EDIT_MODAL_SET,
    UNIT_DETAIL,
    UNIT_DETAIL_SUCCESS,
    UNIT_DETAIL_ERROR,
    UNIT_UPDATE,
    UNIT_UPDATE_SUCCESS,
    UNIT_UPDATE_ERROR
} from "../actions";

export const NAME = 'unit';

export const UnitList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: UNIT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UnitListSuccess = (data) => ({
    type: UNIT_LIST_SUCCESS,
    payload: data
});

export const UnitListError = (error) => ({
    type: UNIT_LIST_ERROR,
    payload: error
});

export const UnitPageSet = (data) => ({
    type: UNIT_PAGE_SET,
    payload: data
});

export const UnitHeader = (data) => ({
    type: UNIT_HEADER,
    payload: data
})

export const UnitSearchSet = (data) => ({
    type: UNIT_SEARCH_SET,
    payload: data
});

export const UnitSearchChangeSet = (data) => ({
    type: UNIT_SEARCH_CHANGE,
    payload: data
});


export const UnitAddChangeSet = (data) => ({
    type: UNIT_ADD_CHANGE,
    payload: data
});

export const UnitAddSet = (data) => ({
    type: UNIT_ADD_SET,
    payload: data
});

export const UnitAddModalSet = (data) => ({
    type: UNIT_ADD_MODAL_SET,
    payload: data
});

export const UnitAdd = (data) => ({
    type: UNIT_ADD,
    payload: data
});

export const UnitAddSuccess = (message) => ({
    type: UNIT_ADD_SUCCESS,
    payload: message
});

export const UnitAddError = (error) => ({
    type: UNIT_ADD_ERROR,
    payload: error
});

export const UnitEditSet = (data) => ({
    type: UNIT_EDIT_SET,
    payload: data
});

export const UnitEditChangeSet = (data) => ({
    type: UNIT_EDIT_CHANGE,
    payload: data
});

export const UnitEditModalSet = (data) => ({
    type: UNIT_EDIT_MODAL_SET,
    payload: data
});

export const UnitEditTabSet = (data) => ({
    type: UNIT_EDIT_TAB_SET,
    payload: data
});

export const UnitDetail = (data) => ({
    type: UNIT_DETAIL,
    payload: data
});

export const UnitDetailSuccess = (data) => ({
    type: UNIT_DETAIL_SUCCESS,
    payload: data
});

export const UnitDetailError = (error) => ({
    type: UNIT_DETAIL_ERROR,
    payload: error
});

export const UnitUpdate = (data) => ({
    type: UNIT_UPDATE,
    payload: data
});

export const UnitUpdateSuccess = (message) => ({
    type: UNIT_UPDATE_SUCCESS,
    payload: message.message
});

export const UnitUpdateError = (error) => ({
    type: UNIT_UPDATE_ERROR,
    payload: error
});



const unit = (state) => state[NAME];

export const UnitSelector = createStructuredSelector({
    unit
})
